module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-question-circle-o',\n    title: 'Help',\n    description: 'General info and how to get in touch with us.'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/help/help.section-header.html
// module id = 4149
// module chunks = 86